import { setIsAuth } from 'redux/slices/app/app.slice';
import { EReduxQueryTags, ProfileResponse, UpdateProfileRequest } from 'shared/types/api.interface';
import { queryUrls } from 'shared/constants/queryApiUrl-constants';
import { PROFILE_FETCHES_SUCCESS } from 'shared/constants/alert-constants';
import { handleSnackbarNotify } from 'utils/handleSnackbarNotify';
import { handleCatchNotValidationError } from 'utils/handleCatchNotValidationError';
import { splitApi } from './split.api';

export const UserApi = splitApi.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query<ProfileResponse, void>({
      query: () => ({
        url: queryUrls.userApi.getProfile,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setIsAuth(true));
        } catch (err) {
          handleCatchNotValidationError(err, dispatch);
        }
      },
      providesTags: [EReduxQueryTags.User],
      keepUnusedDataFor: 360 * 4,
    }),
    updateProfile: build.mutation<ProfileResponse, UpdateProfileRequest>({
      query: (body) => ({
        url: queryUrls.userApi.updateProfile,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result) => {
        if (result) return [EReduxQueryTags.User];
        return [];
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          handleSnackbarNotify(dispatch, PROFILE_FETCHES_SUCCESS.fetchUpdateProfile, 'success');
        } catch (err) {
          handleCatchNotValidationError(err, dispatch);
        }
      },
    }),
  }),

  overrideExisting: false,
});

export const { useGetProfileQuery, useUpdateProfileMutation } = UserApi;
